<template>
  <div class="admin-home">
    <div class="head">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="text-white">Current Serving</h1>
        </div>
        <div class="col-md-6">
          <h1 class="text-white text-end">No. of Barber: {{ staff_number }}</h1>
        </div>
      </div>
    </div>
    <div class="next py-3 text-center">
      <button
        class="btn next-btn btn-dark py-3 px-5"
        @click="clickNext"
        v-if="is_next_token"
      >
        NEXT <i class="fa px-2 fa-arrow-right"></i>
      </button>
      <button class="btn next-btn btn-secondary py-3 px-5" disabled v-else>
        All Staffs Busy <i class="fa px-2 fa-spinner"></i>
      </button>
    </div>
    <template v-if="tokens">
      <div v-for="(token, key) in tokens" :key="key" class="my-5">
        <template v-if="key != 'is_next_token'">
          <h2>{{ textTransform(key) }}</h2>
          <table class="table">
            <thead style="background: #237a79; padding: 50px">
              <tr>
                <th class="fw-bolder text-white" scope="col">Token No.</th>
                <th class="fw-bolder text-white" scope="col">Contact Number</th>
                <th class="fw-bolder text-white" scope="col">
                  Selected Service
                </th>
                <th class="fw-bolder text-white" scope="col">Start Time</th>
                <th class="fw-bolder text-white" scope="col">End Time</th>
                <th class="fw-bolder text-white" scope="col">Action</th>
                <th
                  class="fw-bolder text-white"
                  scope="col"
                  v-if="token && token[0] && token[0].status == 5"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="t of token" :key="t.id">
                <td class="fw-bold">{{ t.token_number }}</td>
                <td>{{ t.contact_number }}</td>
                <td>{{ t.service.title }}</td>
                <td>{{ changeTimeToHIA(t.approach_start_time) }}</td>
                <td>{{ changeTimeToHIA(t.approach_end_time) }}</td>
                <td>
                  <span
                    class="mx-2"
                    @click="changeTokenStatus(t.id, 3)"
                    title="Cancel"
                  >
                    <img class="cancel-icon" src="@/assets/images/cancel.png" />
                  </span>
                  <span
                    class="mx-3"
                    v-if="t.status != 4"
                    @click="changeTokenStatus(t.id, 4)"
                    title="Hold"
                  >
                    <img class="hold-icon" src="@/assets/images/hold.png" />
                  </span>
                  <span
                    class="mx-2 btn btn-success"
                    v-if="t.status == 1"
                    @click="changeTokenStatus(t.id, 2)"
                    >DONE</span
                  >
                  <span
                    class="mx-3"
                    v-if="t.status == 4"
                    @click="changeTokenStatus(t.id, 0)"
                    ><img class="hold-icon" src="@/assets/images/queue.png"
                  /></span>

                  <span
                    class="btn btn-secondary"
                    v-if="t.notification_status == 0 && t.status == 0"
                    @click="sendSMS(t)"
                    >Reminder SMS</span
                  >
                  <span
                    class="btn btn-success"
                    v-if="t.notification_status == 1 && t.status == 0"
                    >SENT</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import util from "@/util/util";
import { mapMutations } from "vuex";
export default {
  name: "Dashboard",

  mounted() {
    this.bindEvent();
    this.isLoading(true);
    this.getActiveStaffNumber();
    this.fetchTokens();
  },
  data() {
    return {
      tokens: null,
      staff_number: 0,
      is_next_token: true,
    };
  },
  methods: {
    changeTimeToHIA(val) {
      return util.changeTimeFormat(val);
    },
    textTransform(val) {
      return util.camelCase(val);
    },
    bindEvent() {
      console.log("Binding Event");
      util.bindEvent.call(this, {
        channelName: "GenerateTokenFromFrontEnd",
        eventName: "GenerateTokenFromFrontEnd",
        callback: () => {
          this.fetchTokens();
        },
      });
    },
    getActiveStaffNumber() {
      this.$http.get("/user/staff-numbers").then((res) => {
        this.isLoading(false);
        if (res.data.status == 1) {
          this.staff_number = res.data.data;
          this.$notify({
            group: "notifications",
            title: res.data.data.message,
            type: "success",
            text: res.data.message,
          });
        } else {
          this.$notify({
            group: "notifications",
            title: res.data.message,
            type: "error",
            text: res.data.errors[0],
          });
        }
      });
    },
    clickNext() {
      this.isLoading(true);
      this.$http
        .get("/token/next")
        .then((res) => {
          if (res.data.status == 1) {
            if (res.data.data.audioUrl) {
              var audio = new Audio(res.data.data.audioUrl);
              console.log(audio);
              audio.play();
            }
            this.fetchTokens();
            this.$notify({
              group: "notifications",
              title: res.data.data.message,
              type: "success",
              text: res.data.message,
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "notifications",
            title: "Error",
            type: "error",
            text: err,
          });
        })
        .finally(() => {
          this.isLoading(false);
        });
    },
    fetchTokens() {
      this.$http.get("/token/daily").then((response) => {
        this.tokens = response.data.data;
        this.is_next_token = response.data.data.is_next_token;
        console.log(this.tokens);
        this.isLoading(false);
      });
    },
    ...mapMutations({
      isLoading: "loading",
    }),
    changeTokenStatus(id, status) {
      this.isLoading(true);
      this.$http({
        url: "/token/change-status",
        data: {
          token_id: id,
          status: status,
        },
        method: "post",
      })
        .then((res) => {
          if (res.data.status == 1) {
            this.fetchTokens();
            this.$notify({
              group: "notifications",
              title: res.data.data.message,
              type: "success",
              text: res.data.message,
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          this.$notify({
            group: "notifications",
            title: "Error",
            type: "error",
            text: err,
          });
        })
        .finally(() => {
          this.isLoading(false);
        });
    },
    sendSMS(token) {
      this.$http({
        url: "token/notification/" + token.id,
        method: "get",
      }).then((resp) => {
        if (resp.data.status == 1) {
          this.fetchTokens();
          console.log("Sms Sent");
        } else {
          this.$notify({
            group: "notifications",
            title: resp.data.message,
            type: "error",
            text: resp.data.errors[0],
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.hold-icon {
  width: 30px;
  cursor: pointer;
}
.cancel-icon {
  width: 25px;
  cursor: pointer;
}
.next-btn {
  background-color: #031c76;
  font-size: 1.5rem;
  font-weight: 600;
}
</style>
